import PropTypes from 'prop-types'

import Text from 'components/common/Text'
import theme from 'theme'
import { stripText } from 'utils/strings'

export const flattenTooltipErrors = (values) => {
  if (values === undefined) return

  if (typeof values === 'string') {
    return values
  }

  return Object.values(values)
    .flatMap((value) => {
      return flattenTooltipErrors(value)
    })
    .filter(Boolean)
}

const TooltipContents = ({ tooltipText, stripArray }) => {
  const type = typeof tooltipText

  if (type === 'string') {
    return (
      <Text as="p" color="white">
        {stripText(tooltipText, stripArray)}
      </Text>
    )
  }

  if (tooltipText.length === 1) {
    return (
      <Text as="p" color="white">
        {stripText(tooltipText[0], stripArray)}
      </Text>
    )
  }

  return (
    <ul css={{ paddingLeft: theme.space[3] }}>
      {tooltipText.map((tooltip) => {
        return (
          <li
            key={`configuration ${tooltip}`}
            css={{ color: theme.colors.white[0] }}
          >
            <Text as="p" color="white">
              {stripText(tooltip, stripArray)}
            </Text>
          </li>
        )
      })}
    </ul>
  )
}

TooltipContents.defaultProps = {
  tooltipText: [],
  stripArray: []
}

TooltipContents.propTypes = {
  tooltipText: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  stripArray: PropTypes.array
}

export default TooltipContents
